import React, { Component } from "react";
import { getDisplayName } from "./../../wix-rich-content-common/index.js";
function decorateWithComponentProps(EmbeddedComponent, extraProps) {
  var _a;
  return _a = class extends Component {
    render() {
      return /* @__PURE__ */ React.createElement(EmbeddedComponent, { ...this.props, ...extraProps });
    }
  }, _a.displayName = `Decorated(${getDisplayName(EmbeddedComponent)})`, _a;
}
export {
  decorateWithComponentProps as default
};
//# sourceMappingURL=decorateComponentWithProps.js.map
